<template>
    <div>
        <div id="content" class="w">
            <div class="s_tl">
                <span class="left">
                    <a href="/">首页</a>
                    <code class="lr3">&#62;</code>
                    <a href="javascript:;">搜索</a>
                    <code class="lr3">&#62;</code>
                </span>
                <ul class="left s_sx">
                    <li><a class="d_xx" href="javascript:;">{{key_cate_pro.keywords}}</a></li>
                </ul>
                <div class="right">共找<b class="c3">{{tableData.total}}</b>件</div>
            </div>
            <div class="scat over">
                <dl class="sdl sfst">
                    <dt><b class="red">分类</b></dt>
                    <dd>
                        <span v-for="(cate,index) in key_cate_pro.cate" :key="index">
                            <router-link :to="{path:'/shop/shopsearch', query:{cate_id:cate.id}}" target="_blank" class="sd_aa">
                                {{cate.title}}
                            </router-link>
                        </span>
                    </dd>
                </dl>
            </div>
            <!--cat over-->

            <div class="sxbox">
                <div class="ls_cat" id="ls_cat">
                    <div class="w">
                        <div class="left pl10">
                            <a rel="nofollow" href="javascript:;" class="sb_a " @click="getPrice('综合')" :class="{sb_on:tableFrom.order_sn==''}">综合</a>
                            <a rel="nofollow" href="javascript:;" class="sb_a" @click="getPrice('销量')" :class="{sb_on:tableFrom.order_sn=='invent_sale_desc'}">销量</a>
                            <a rel="nofollow" href="javascript:;" class="sb_a" @click="getPrice" :class="[tableFrom.order_sn=='price_asc' || tableFrom.order_sn=='price_desc'?'sb_on ':'']"><em class="pr10">价格</em><i class="rjg"></i></a>
                        </div>
                        <!-- <div class="prt right"> 
                            <span class="left mr10" id="page_nmx">1/3</span>
                            <a class="pr_a p_off" href="javascript:goPrev();" id="tprev">上一页</a> 
                            <a class="pr_a" href="javascript:goNext();" id="tpnxt">下一页</a>
                        </div> -->
                    </div>
                </div>
            </div>
            <p id="loading" class="lding hid"><em class="lod_ico">加载中,请稍候....</em></p>
            <div class="gdls" id="gdls">
                <dl class="gl" v-for="(items,indexs) in tableData.data" :key="indexs" @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                    <dt>
                        <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank">
                            <img :src="items.piclink" width="270" height="270" class="sbm">
                        </router-link>
                    </dt>
                    <!-- <dd class="simg">
                        <img src="https://s.cccgx.com/t/26x26/images/qu/10201/gallery/20211025025923_30410.jpg" width="26" height="26" class="ss_m">
                    </dd> -->
                    <dd>
                        <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank" class="gna pt10">
                            {{items.title}}
                        </router-link>
                        <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank" class="pt_g mt5">
                            {{items.sub_title}}
                        </router-link>
                    </dd>
                    <dd class="gp_d">
                        <i class="rmb left">¥</i>
                        <b class="xj left">{{items.price}}</b>
                        <em class="cs_o">已售{{items.invent_sale}}件</em>
                    </dd>
                    <dd class="pt5">
                        <em class="i_hot">热销</em>
                        <i class="i_by">包邮</i>
                    </dd>
                </dl>
            </div>
            <div class="page" id="pager">
                <!-- <paging :total="total" :current-page='current' :refresh='refresh' @pagechange="pagechange"></paging> -->
                <el-pagination :page-sizes="[20, 40, 60, 80]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
            </div>
            <div class="ftj">
                <b class="bl_red tuijian" style="">热门推荐:</b>
                <span v-for="(cate,index) in key_cate_pro.cate" :key="index">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:cate.id}}" target="_blank" class="sd_aa">
                        {{cate.title}}
                    </router-link>
                </span>
            </div>
            <div class="b_li">
                <div v-for="(hot,index) in key_cate_pro.data" v-if="index < 4" :key="index" @mouseenter="mouseEnters($event)" @mouseleave="mouseLeaves($event)" class="dn_a">
                    <router-link :to="{path:'/detail', query:{id:hot.id}}" target="_blank">
                        <img :src="hot.piclink" width="270" height="270" class="sbm">
                        <div class="h250">
                            <p class="gna pt10">{{hot.title}}</p>
                            <p class="pt_g">
                                <em class="p_tag">{{hot.sub_title}}</em>
                            </p>
                            <p class="gp_d mt5">
                                <i class="rmb left">¥</i>
                                <b class="xj left mr5">{{hot.price}}</b>
                                <em class="cs_o">已售{{hot.sale}}件</em>
                            </p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!--content over-->
    </div>
</template>

<script>
import Paging  from '@/components/common/paginate'
export default{
    components: {
        'paging': Paging,
    },
    data(){
        return{
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                order_sn: this.$route.query.order_sn ? this.$route.query.order_sn : "",
                keywords:  this.$route.query.keywords ? this.$route.query.keywords : "",
                page: 1,
                limit: 20,
                type: "1",
                title: "",
                sid_cn: "",
                cate_id: ""
            },

            // form: {
            //     title: "",
            //     sid_cn: "",
            //     order_sn: "",
            //     cate_id: ""
            // },
            // product:[],
            keywords:"",
            key_cate_pro:[],
            cate_id: 0,
            cate: [],
            value1: 0,
            value2: '',
            option1: [
                { text: '综合', value: 0 },
                { text: '新款商品', value: 1 },
                { text: '活动商品', value: 2 }
            ],
            option2: [
                { text: '价格', value: '' },
                { text: '价格正序', value: 'price_asc' },
                { text: '价格倒叙', value: 'price_desc' },
            ],
            searchCon: true,
            searchArr: [],
            longClick: null,
            timeOutEvent: null,
        }
    },
    mounted(){
        // if (this.$route.query.hasOwnProperty("order_sn")) {
        //     this.tableFrom.order_sn = this.$route.query.order_sn;
        // } else {
        //     this.tableFrom.order_sn = "";
        // }
        this.getList(1);
        this.getFuzzySearch(this.$route.query.keywords)
        this.getKeywordsCateProduct(this.$route.query.keywords)
    },
    methods:{
        
        getFuzzySearch(keywords){
            var params = {};
            params.keywords = keywords || "";
            this.dialogVisible = true;
            this.LogLoading = true;
            this.$api.getShop.getFuzzySearch(params, this.tableFrom).then(res => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.tableData.keywords = keywords;
                    this.tableData.total = res.result.count  // 总条目数
                    this.listLoading = false;
                }
            }).catch((res) => {
                    this.$message.error(res.message);
                    this.listLoading = false;
                });
        },
        // 列表
        getList(num) {
            // var params = {};
            // params.keywords = keywords || "";
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getFuzzySearch(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.keywords = this.$route.query.keywords;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.limit = res.result.pageSize;
                    this.listLoading = false;
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        getKeywordsCateProduct(keywords){
            var params = {};
            params.keywords = keywords || "";
            this.$api.getShop.getKeywordsCateProduct(params).then(res => {
                if (res.code == 200) {
                    this.key_cate_pro = res.result;
                    this.key_cate_pro.keywords = keywords;
                }
            });
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
        //   鼠标移入
        mouseEnters($event){
            $event.currentTarget.className="dn_a hov";
        },
        //   鼠标移除
        mouseLeaves($event){
            $event.currentTarget.className="dn_a";
        },
        getPrice (str) {
            if (str == '综合') {
                this.tableFrom.order_sn = ''
            } else if (str == '销量') {
                this.tableFrom.order_sn = 'invent_sale_desc'
            } else if (this.tableFrom.order_sn == 'price_asc') {
                this.tableFrom.order_sn = 'price_desc'
            } else {
                this.tableFrom.order_sn = 'price_asc'
            }
            console.log(this.$emit("setSearch", this.tableFrom));
            this.$emit("setSearch", this.tableFrom);
        },
    }
}
</script>

<style scoped>
.tuijian{
float:left;display: inline;float: left;margin: 6px 0;padding: 0 15px;white-space: nowrap;line-height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/search/Index.vue